export const SHORTLIST_CANDIDATE = "SHORTLIST_CANDIDATE";
export const PROGRAM_TO_UPDATE = "PROGRAM_TO_UPDATE";
export const SHOW_PROGRAM_UPDATE_MODAL = "SHOW_PROGRAM_UPDATE_MODAL";
export const SHOW_AI_CHAT = "SHOW_AI_CHAT";
export const AI_CHAT_PROGRAM_CONTEXT = "AI_CHAT_PROGRAM_CONTEXT";
export const AI_CHAT_PLANNER_CONTEXT = "AI_CHAT_PLANNER_CONTEXT";
